export var WebStorageType = /*#__PURE__*/function (WebStorageType) {
  WebStorageType["LocalStorage"] = "LocalStorage";
  WebStorageType["SessionStorage"] = "SessionStorage";
  return WebStorageType;
}({});